/* eslint-disable react/react-in-jsx-scope */
const SwitchList = ({ view, setView, showFolderView = true }) => {
  return (
    <div className="flex items-center bg-[#0000]">
      <p className="mb-0 mr-1">Vue :</p>
      {showFolderView && (
        <div
          className={`cursor-pointer px-2 py-2 rounded-l-full ${
            view == "folder" ? "" : "opacity-30"
          }`}
          onClick={() => {
            setView("folder");
          }}
        >
          <svg
            className="h-5 w-5 text-foreground"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v1H3z" />
            <path d="M3 10h18v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          </svg>
        </div>
      )}
      <div
        className={`cursor-pointer  px-2 py-2 ${
          view == "list" ? "" : "opacity-30"
        }`}
        onClick={() => {
          setView("list");
        }}
      >
        <svg
          className="h-5 w-5 text-foreground"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="8" y1="6" x2="21" y2="6" />
          <line x1="8" y1="12" x2="21" y2="12" />
          <line x1="8" y1="18" x2="21" y2="18" />
          <line x1="3" y1="6" x2="3.01" y2="6" />
          <line x1="3" y1="12" x2="3.01" y2="12" />
          <line x1="3" y1="18" x2="3.01" y2="18" />
        </svg>
      </div>
      <div
        className={`${
          view == "card" ? "" : "opacity-30"
        } cursor-pointer px-2 py-2 ${showFolderView ? "rounded-r-full" : "rounded-full"}`}
        onClick={() => {
          setView("card");
        }}
      >
        <svg
          className="h-5 w-5 text-foreground"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="3" width="7" height="7" />
          <rect x="14" y="3" width="7" height="7" />
          <rect x="14" y="14" width="7" height="7" />
          <rect x="3" y="14" width="7" height="7" />
        </svg>
      </div>
    </div>
  );
};
export default SwitchList;
